import { BarChart3, BookOpen, Shield, Sparkles, Users, type LucideIcon } from 'lucide-react'

// Decorative multi-hue gradients + icons for library/course covers without a
// custom thumbnail. Picked deterministically by id (no Math.random — banned in
// some runtimes and it would reshuffle on every render anyway).
export const COVER_GRADIENTS = [
  'from-indigo-900 to-purple-900',
  'from-emerald-900 to-slate-900',
  'from-amber-900 to-stone-900',
  'from-sky-900 to-slate-900',
  'from-rose-900 to-slate-900',
  'from-fuchsia-900 to-indigo-900',
]
const COVER_ICONS: LucideIcon[] = [Shield, Users, BarChart3, BookOpen, Sparkles]

function hash(s: string): number {
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0
  return h
}

export function gradientFor(id: string): string {
  return COVER_GRADIENTS[hash(id) % COVER_GRADIENTS.length]
}

export function iconFor(id: string): LucideIcon {
  return COVER_ICONS[hash(id) % COVER_ICONS.length]
}
